import { render, staticRenderFns } from "./ShowUserProfile.vue?vue&type=template&id=298e094c&"
import script from "./ShowUserProfile.vue?vue&type=script&lang=js&"
export * from "./ShowUserProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports